module.exports = __webpack_public_path__ + "static/media/AirgongWhite.3c94548c.svg";